/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DecideTradeScheduleRequest } from '../../models/decide-trade-schedule-request';
import { TradeApprovalRequestResponse } from '../../models/trade-approval-request-response';

export interface DecideTradeScheduleRequest$Params {

/**
 * Trade request id.
 */
  id: number;
      body: DecideTradeScheduleRequest
}

export function decideTradeScheduleRequest(http: HttpClient, rootUrl: string, params: DecideTradeScheduleRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<TradeApprovalRequestResponse>> {
  const rb = new RequestBuilder(rootUrl, decideTradeScheduleRequest.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TradeApprovalRequestResponse>;
    })
  );
}

decideTradeScheduleRequest.PATH = '/api/scheduler/trade-schedule-requests/{id}/decision';
